import { apiRequest } from './client';
import type { ChatResponse } from './types';

export function sendChatMessage(params: {
  userId: string;
  text: string;
  sessionId?: string | null;
}): Promise<ChatResponse> {
  return apiRequest<ChatResponse>('/chat/messages', {
    method: 'POST',
    body: JSON.stringify({
      user_id: params.userId,
      text: params.text,
      session_id: params.sessionId || null,
    }),
  });
}
